export default "__VITE_ASSET__ClBuxwS9__"